import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { convertToRaw, ContentState, EditorState } from 'wix-rich-content-editor-common';
import { getFeature } from './Features/helper';
import { IS_EMPTY_FEATURE, WORD_COUNT_FEATURE } from './Features';
import immutable from 'immutable';
import { attachImage } from '../DaEditor/plugins/plugin-image/modifiers';
import i18next from 'i18next';
/**
 * State we carry on the client
 *
 * @param raw
 * @param editorState
 * @param features
 */ export function convertToClientStorageState(rawContentState, contentState, featuresData) {
    return {
        editorText: {
            excerpt: '',
            html: {
                type: 'draft',
                markup: JSON.stringify(rawContentState),
                features: JSON.stringify(featuresData)
            }
        },
        html: ''
    };
}
export function convertToServerXhrPayload(rawContentState, contentState, featuresData) {
    const { editorText } = convertToClientStorageState(cleanEmptyAtomicBlocks(rawContentState), contentState, featuresData);
    return {
        editorRaw: editorText.html.markup
    };
}
export function textToPapiEditorText(text) {
    const contentState = ContentState.createFromText(text);
    const rawContentState = convertToRaw(contentState);
    return {
        excerpt: '',
        html: {
            type: 'draft',
            markup: JSON.stringify(rawContentState),
            features: '[]'
        }
    };
}
export function createWithDeviation(_param) {
    var { extended } = _param, deviation = _object_without_properties(_param, [
        "extended"
    ]);
    const text = EditorState.createWithContent(ContentState.createFromText(i18next.t('editor.shareToPost.text')));
    const editorState = attachImage(deviation, EditorState.moveSelectionToEnd(text));
    const contentState = editorState.getCurrentContent();
    const rawContentState = convertToRaw(contentState);
    return {
        excerpt: '',
        html: {
            type: 'draft',
            markup: JSON.stringify(rawContentState),
            features: '[]'
        }
    };
}
export function createWithDeviationAndText(_param, text = i18next.t('editor.shareToPost.text')) {
    var { extended } = _param, deviation = _object_without_properties(_param, [
        "extended"
    ]);
    const editorText = EditorState.createWithContent(ContentState.createFromText(text));
    const editorState = attachImage(deviation, EditorState.moveSelectionToEnd(editorText));
    const contentState = editorState.getCurrentContent();
    const rawContentState = convertToRaw(contentState);
    return {
        excerpt: '',
        html: {
            type: 'draft',
            markup: JSON.stringify(rawContentState),
            features: '[]'
        }
    };
}
export function getEmptyServerXhrPayload() {
    const emptyContentState = ContentState.createFromText('');
    const { editorText } = convertToClientStorageState(cleanEmptyAtomicBlocks(convertToRaw(emptyContentState)), emptyContentState, []);
    return {
        editorRaw: editorText.html.markup
    };
}
/**
 * Removes empty unstyled blocks from around atomics
 *
 * @param raw
 */ function cleanEmptyAtomicBlocks(raw) {
    const isEmpty = (block)=>{
        return block.text === '' && block.type === 'unstyled' && block.inlineStyleRanges.length === 0 && block.entityRanges.length === 0;
    };
    raw.blocks = raw.blocks.filter((block, idx)=>{
        const next = raw.blocks[idx + 1];
        const prev = raw.blocks[idx - 1];
        if (next && next.type === 'atomic' || prev && prev.type === 'atomic') {
            // Empty and NOT the first or last block
            // Stripping first/last block will break editor, viewer will hide these anyway.
            if (idx !== 0 && idx !== raw.blocks.length - 1 && isEmpty(block)) {
                return false;
            }
        }
        return true;
    });
    return raw;
}
/**
 * Test if the state has changed, note this does not check content
 * equality, so editing and undoing is seen as a change.
 *
 * @param prev
 * @param next
 */ export function hasChanged(prev, prevRaw, next, nextRaw) {
    if (!immutable.is(prev, next)) {
        return true;
    }
    try {
        if (JSON.stringify(prevRaw.entityMap) !== JSON.stringify(nextRaw.entityMap)) {
            return true;
        }
    } catch (e) {
    /* noop */ }
    return false;
}
export function isEditorTextEmpty(editorText) {
    let isEmpty;
    const isEmptyFeature = getFeature(IS_EMPTY_FEATURE, editorText.html.features);
    if (isEmptyFeature) {
        isEmpty = isEmptyFeature && isEmptyFeature.data.isEmpty;
    } else {
        const wordCountFeature = getFeature(WORD_COUNT_FEATURE, editorText.html.features);
        isEmpty = wordCountFeature && wordCountFeature.data.chars === 0;
    }
    return isEmpty;
}
export function isInsideEditor(element) {
    if (typeof document === 'undefined') {
        return;
    }
    const editors = document.querySelectorAll('.DraftEditor-root,[data-daeditor-retrieved-toolbar]');
    return Array.from(editors).some((editor)=>editor.contains(element));
}
